import * as actionTypes from '../actions/actionTypes';

const initialState = {notifications: [{id: 'id', active: true, productId: 'someId', msg: ''}]}

const notificationsReducer = (state=initialState, action) => {
    switch(action.type) {
        case actionTypes.FETCH_NOTIFICATIONS: {
            return {
                ...state,
                notifications: action.data
            }
        }
        case actionTypes.CREATE_NOTIFICATION: {
            console.log('----------', action)
            return {
                ...state,
                notifications: [...state.notifications, action.data]
            }
        }
        case actionTypes.UPDATE_NOTIFICATION: {
            console.log('----------', action)
            return {
                ...state,
                notifications: state.notifications.map((item) => {
                    if(item.id === action.id) {
                        return {...item, active: false}
                    }
                    return item
                })
            }
        }
        case actionTypes.DELETE_NOTIFICATION: {
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.id !== action.id)
            }
        }
        case actionTypes.CLEAR_SALE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

export default notificationsReducer;